import axios from 'axios'

const LaterPostingService = {
  async get (params = {}) {
    return axios.get('wo/purchase-order/request-later-postings', { params })
  },

  async show (id) {
    return axios.get(`wo/purchase-order/request-later-postings/${id}`)
  },

  async post (params = {}) {
    return axios.post('wo/purchase-order/request-later-postings', params)
  },

  async put (params = { id: '' }) {
    return axios.put(`wo/purchase-order/request-later-postings/${params.id}`, params)
  },

  async delete (data = { id: '' }) {
    return axios.delete(`wo/purchase-order/request-later-postings/${data.id}`, { data })
  }
}

export default LaterPostingService
